import React from "react";
import { Grid } from "@material-ui/core";
import DynamicInput from "@icarius-common/dynamicInputs";
import PlayButton from "@icarius-common/audioPlayer/components/playButton";
import { getLocalizedString } from "@icarius-localization/strings";
import SectionContainer from "./sectionContainer";

const GenericSection = (props) => {

    const {
        title,
        subtitle,
        sectionFields,
        formData,
        setFormValue,
        fullSizeColumn,
    } = props;

    const getAudioPlayer = (name) => {
        switch (name) {
            case "DISCLAMER":
                return (
                    <PlayButton audioName="Consentimiento para firma digital" title={getLocalizedString("digitalSignatureConsent")} />
                );
            case "GRUPOEMP":
                return (
                    <PlayButton audioName="Grupo para acceso de administradores" title={getLocalizedString("accessGroupAdmin")} />
                );
            default: return null;
        }
    }

    const getFieldOptions = (field, fieldName) => {
        if (fieldName === "OBLIGATORY_FIELDS_EMPLOYEE_MASTER" && Array.isArray(field?.options)) {
            return field.options.map((opt) => {
                const id = opt.id !== undefined ? opt.id : opt.key;
                const uId = opt.U_id || (id !== undefined ? (String(id).startsWith("U_") ? id : `U_${id}`) : "");
                if (!uId) return opt;

                if (!opt.value?.includes?.(`(${uId})`)) {
                    const cleanValue = id ? opt.value.replace(new RegExp(`\\s*\\(${id}\\)$`), "") : opt.value;
                    return {
                        ...opt,
                        value: `${cleanValue} (${uId})`,
                    };
                }
                return opt;
            });
        }
        return field?.options;
    };

    const columns = !sectionFields || !sectionFields.length
        ? []
        : Array.isArray(sectionFields[0])
            ? sectionFields
            : [sectionFields];

    return (
        <SectionContainer
            title={title}
            subtitle={subtitle}
        >
            {
                columns.map((fieldsByColumn, columnIndex) => {

                    return (
                        <Grid item xs={12} md={fullSizeColumn ? 12 : 6} key={columnIndex}>
                            {
                                fieldsByColumn.map((item, itemIndex) => {
                                    const field = Object.values(item)[0];
                                    const fieldName = Object.keys(item)[0];


                                    if (!field || !field.type) {
                                        return (
                                            <Grid
                                                key={itemIndex}
                                                container item alignItems="center" xs={12}
                                                style={{ paddingBottom: 15 }}
                                            >
                                                <div style={{ height: 48 }} />
                                            </Grid>
                                        )
                                    }

                                    if (fieldName === "DELETE_PROCESS_SQL") return null; // se hardcodea por fuera

                                    return (
                                        <Grid
                                            key={itemIndex}
                                            container item alignItems="center" xs={12}
                                            style={{ paddingBottom: 15 }}
                                        >
                                            <DynamicInput
                                                fieldConfig={{
                                                    ...field,
                                                    name: fieldName,
                                                    type: field.type,
                                                    editable: true,
                                                    options: getFieldOptions(field, fieldName),
                                                    multiple: field.multiple,
                                                    audioPlayer: getAudioPlayer(fieldName),
                                                }}
                                                label={field.name || getLocalizedString(fieldName)}
                                                value={formData[fieldName]}
                                                handleChange={setFormValue}
                                            />
                                        </Grid>
                                    );
                                })
                            }
                        </Grid>
                    )

                })
            }
        </SectionContainer>
    )
}

export default GenericSection;